export const BASE_URL = "https://nyxbackend-cteo.onrender.com"